import { Property, PropertyType } from '../../../../base/types';

import { IProperty } from '../../../../base/models';

export const IFrameProperties: IProperty[] = [
    { id: Property.CancelPageLink, name: 'Navigate To on Bookings', type: PropertyType.PageLink },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String },
    { id: Property.Url, name: 'Url', type: PropertyType.Url },
]
